import { Text } from '@/components/atoms/text';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface HistoricalInfoContainerProps {
  width?: string;
}

export const HistoricalInfoContainer = styled(Box)<HistoricalInfoContainerProps>(
  ({ theme, width }) => ({
    width: width || 'auto',
    minWidth: '480px',
    maxWidth: 'min(620px, 90vw)',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1),
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      minWidth: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  })
);

export const HistoricalInfoHeader = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const HistoricalInfoContent = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const HistoricalInfoItem = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(6),
  [theme.breakpoints.down('xmd')]: {
    flexWrap: 'wrap',
  },
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(1),
    flexDirection: 'column',
  },
}));

interface TitleProps {
  width?: string;
  minWidth?: string;
}
const shouldForwardProp = (prop: PropertyKey) => !['width', 'minWidth'].includes(prop as string);

export const Title = styled(Text, { shouldForwardProp })<TitleProps>(
  ({ theme, width, minWidth }) => ({
    width: width || 'auto',
    minWidth: minWidth || '120px',
    maxWidth: '180px',
    flexShrink: 0,
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.body2.fontWeight,
    color: theme.palette.text.secondary,
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: '100%',
      minWidth: 'auto',
    },
  })
);

interface ValueProps {
  width?: string;
}

export const Value = styled(Text, { shouldForwardProp })<ValueProps>(({ theme, width }) => ({
  width: width || 'auto',
  flex: 1,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.body2.fontWeight,
  color: theme.palette.text.primary,
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
  whiteSpace: 'normal',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));
